import { call, put } from 'redux-saga/effects';
import {
    setClasificacionMovimientos,
    savedClasificacionMovimiento,
} from '../../ducks/clasificacionMovimientos';
import {
    requestLoadClasificacionMovimientos,
    requestSaveClasificacionMovimiento,
} from '../requests/clasificacionMovimientos';

export function* handleLoadClasificacionMovimientos() {
    try {
        const response = yield call(requestLoadClasificacionMovimientos);
        yield put(setClasificacionMovimientos(response.data));
    } catch (error) {
        console.log(error);
    }
}

export function* handleSaveClasificacionMovimiento(action) {
    try {
        const response = yield call(requestSaveClasificacionMovimiento, action.clasificacion);
        yield put(savedClasificacionMovimiento(response.data));
    } catch (error) {
        console.log(error);
    }
}
